import RetailOUCounsellorView from '../users/RetailOUCounsellorView';

export default RetailOUCounsellorView;
